import { FormTab, RadioButtonGroupInput } from "react-admin";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";
import { DriverSelectionGrid } from "./DriverSelectionGrid";

const radioChoices = [
  {
    id: true,
    name: "Select all drivers",
  },
  {
    id: false,
    name: "Select drivers from the list",
  },
];

export const NotificationSubscriptionDriversTab = (props: any) => {
  return (
    <FormTab {...props} label="resources.admin-notifications.labels.drivers">
      <div style={{ paddingTop: "20px", paddingLeft: "20px" }}>
        <ProtectedElement source="isAllDriversSelected">
          <RadioButtonGroupInput
            style={{ width: "100%", display: "flex", flexDirection: "row" }}
            label=""
            source="isAllDriversSelected"
            choices={radioChoices}
            row={true}
            defaultChecked={false}
          />
        </ProtectedElement>
      </div>

      <DriverSelectionGrid {...props} />
    </FormTab>
  );
};
